<template lang="pug">

  text-input(name="last_name", :label="label")

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-last-name',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'Last name',
    },
  },
}

</script>
